module.exports = __webpack_public_path__ + "img/202504_10.d19ad8f5.jpg";